/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

const state = {
  isLoader: true,
};

const getters = {};

const actions = {
  setLoaderState({ commit }, status) {
    commit('setLoader', status);
  },
  loaderOn({ dispatch }) {
    dispatch('setLoaderState', true);
  },
  loaderOff({ dispatch }) {
    dispatch('setLoaderState', false);
  },
};

const mutations = {
  setLoader(state, status) {
    state.isLoader = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
